<template>
  <div class="customer-section">
    <div class="section-title mb-4">Thông tin khách hàng</div>

    <CustomerInfo
      :key="customerInfoKey"
      :bill-data="billDataForCustomerInfo"
      :from-order="false"
      action="create"
      :on-submiting="onSubmiting"
      @onUpdate="onCustomerUpdate"
    />
  </div>
</template>

<script>
import CustomerInfo from '@/view/components/customers/CustomerInfo.vue';
import * as ENUM from '@/utils/enum';

export default {
  name: 'CustomerSection',
  components: { CustomerInfo },
  props: {
    form: { type: Object, required: true },
    mode: { type: [String, Number], default: ENUM.MODE.ADD },
    onSubmiting: { type: Boolean, default: false },
  },
  data() {
    return {
      MODE: ENUM.MODE,
    };
  },
  computed: {
    customerInfoKey() {
      const f = this.form || {};
      return f.id != null ? `edit-${f.customerId ?? 'loading'}` : 'add';
    },
    billDataForCustomerInfo() {
      const f = this.form || {};
      const c = f.customer;
      const dateOfBirth =
        c?.dateOfBirth != null
          ? typeof c.dateOfBirth === 'string'
            ? c.dateOfBirth.slice(0, 10)
            : new Date(c.dateOfBirth).toISOString().slice(0, 10)
          : f.customerDateOfBirth ?? null;
      return {
        customerModel: {
          customerId: f.customerId ?? c?.id ?? null,
          customerMobile: c?.phoneNumber ?? f.customerPhone ?? '',
          customerName: c?.fullName ?? f.customerName ?? '',
          customerEmail: c?.email ?? f.customerEmail ?? '',
          customerAppellation: c?.gender ?? f.customerAppellation ?? null,
          customerAddress: c?.address ?? f.customerAddress ?? '',
          customerType: 1,
          customerDateOfBirth: dateOfBirth,
          wardId: f.customerWardId ?? null,
          totalPoint: 0,
        },
      };
    },
  },
  methods: {
    onCustomerUpdate(customerData) {
      if (!customerData) return;
      this.$emit('update-field', {
        field: 'customerId',
        value: customerData.customerId ?? null,
      });
      this.$emit('update-field', {
        field: 'customerPhone',
        value: customerData.customerMobile ?? '',
      });
      this.$emit('update-field', {
        field: 'customerName',
        value: customerData.customerName ?? '',
      });
      this.$emit('update-field', {
        field: 'customerEmail',
        value: customerData.customerEmail ?? '',
      });
      this.$emit('update-field', {
        field: 'customerAppellation',
        value: customerData.customerAppellation ?? null,
      });
      this.$emit('update-field', {
        field: 'customerAddress',
        value: customerData.customerAddress ?? '',
      });
      this.$emit('update-field', {
        field: 'customerWardId',
        value: customerData.wardId ?? null,
      });
      this.$emit('update-field', {
        field: 'customerDetailAddress',
        value: customerData.detailAddress ?? '',
      });
      this.$emit('update-field', {
        field: 'customerDateOfBirth',
        value: customerData.customerDateOfBirth ?? null,
      });
    },
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 600;
  font-size: 1.05rem;
}
</style>
